import classNames from "classnames";
import Label from "components/Label";
import { motion } from "framer-motion";
import React from "react";
import { framerMotionAnimation } from "utils/animation";
import styles from "./styles.module.scss";

interface Props {
  children?: React.ReactNode;
  className?: string;
  contentClassName?: string;
  id?: string;
  label?: string;
  labelClassName?: string;
  labelType?: "primary" | "secondary";
  style?: React.CSSProperties;
}

const Section: React.FC<Props> = ({
  children,
  className,
  contentClassName,
  id,
  label,
  labelClassName,
  labelType = "primary",
  style,
}) => {
  return (
    <div
      className={classNames(styles.container, className)}
      id={id}
      style={style}
    >
      {label && (
        <motion.div
          className={classNames(styles.label, labelClassName)}
          {...framerMotionAnimation}
        >
          <Label type={labelType} transform="uppercase">
            {label}
          </Label>
        </motion.div>
      )}

      <div className={classNames(styles.content, contentClassName)}>
        {children}
      </div>
    </div>
  );
};

export default Section;
